import { render, staticRenderFns } from "./RequiredLabel.vue?vue&type=template&id=2daf8015&functional=true"
import script from "./RequiredLabel.vue?vue&type=script&lang=js"
export * from "./RequiredLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2daf8015')) {
      api.createRecord('2daf8015', component.options)
    } else {
      api.rerender('2daf8015', component.options)
    }
    module.hot.accept("./RequiredLabel.vue?vue&type=template&id=2daf8015&functional=true", function () {
      api.rerender('2daf8015', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RequiredLabel.vue"
export default component.exports